import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  'rt--notifications--cmp--buttons--see-all-box': {
    display: 'flex',
    justifyContent: 'center',
  },
  'rt--notifications--cmp--buttons--see-all-button-container': {
    background: theme.new.color.common.white,
    borderRadius: '8px',
  },
}));
